export function DeleteIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <g fill="#FFADB5" clipPath="url(#clip0_4776_3431)">
        <path
          d="M6.113 10.387a.495.495 0 01-.353-.147.503.503 0 010-.706L9.533 5.76a.503.503 0 01.707 0 .503.503 0 010 .707L6.466 10.24a.484.484 0 01-.353.147z"></path>
        <path
          d="M9.886 10.387a.495.495 0 01-.353-.147L5.76 6.467a.503.503 0 010-.707.503.503 0 01.706 0l3.774 3.774a.503.503 0 010 .706c-.1.1-.227.147-.354.147z"></path>
        <path
          d="M10 15.167H6c-3.62 0-5.167-1.546-5.167-5.166V6C.833 2.38 2.38.834 6 .834h4c3.62 0 5.167 1.547 5.167 5.167v4c0 3.62-1.547 5.166-5.167 5.166zM6 1.834c-3.073 0-4.167 1.093-4.167 4.167v4c0 3.073 1.094 4.166 4.167 4.166h4c3.073 0 4.167-1.093 4.167-4.166V6c0-3.074-1.094-4.167-4.167-4.167H6z"></path>
      </g>
      <defs>
        <clipPath id="clip0_4776_3431">
          <path fill="#fff" d="M0 0H16V16H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export function AddRowIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <path
        stroke="#5D70B5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M8 2.666v10.667M2.667 8h10.666"
      ></path>
    </svg>
  );
}